<template>
<div data-component="DropdownSelect.vue" class="dropdown" :class="{ 'is-focused': Focused , 'is-arrowless': Arrowless }" @click.prevent.stop="OnClick">
	<button class="dropdown-button" :disabled="Disabled">
		<slot v-if="$slots.label" name="label"/>
		<div v-else v-html="Labels[Value] ? Labels[Value] : Placeholder"/>
	</button>
	<div class="suggestions-list">
		<template v-for="(item, i) in Items">
			<a v-if="item.Value" :data-test="item.DataTest || 'dropdown__option'"  :key="i" :class="item.Class || ''" @click="OnSelect(item)" v-html="item.Label"/>
		</template>
	</div>
</div>
</template>

<script lang="ts">
// @vuese
// Komponent odpowiedzialny za kontrolkę wyboru elementu z listy.
// @group Base Components | Forms
export default {
	name: 'DropdownSelect',
	props: {
		modelValue: { default: '' },
		Items: { default: () => new Array() }, // eslint-disable-line no-array-constructor
		Placeholder: {
			type: String,
			default: '',
		},
		Disabled: {
			type: Boolean,
			default: false,
		},
		Arrowless: {
			type: Boolean,
			default: false,
		},
	},
	emits: ['update:modelValue', 'change'],
	data() {
		return {
			Value: '',
			Labels: {},
			Focused: false,
		};
	},
	watch: {
		modelValue(n) {
			this.Value = n;
		},
		Items(n) {
			this.Labels = {};
			for (const i of n) { this.Labels[i.Value] = i.Label; }
		},
	},
	created() {
		try {
			for (const i of this.Items || []) { this.Labels[i.Value] = i.Label; }
		} catch (err) {

		}
		this.Value = this.modelValue;
	},
	methods: {
		OnClick() {
			if (this.Disabled) { return; }
			this.Focused = !this.Focused;
		},
		OnSelect(i) {
			this.Value = i.Value;
			// TODO: v to nie powinno trafić tutaj, tylko jako obsłużęnie eventu!!!!11
			if(this.Value === 'MyRfps' || this.Value === 'BuyerView') { this.Analytics.GA4Event('ga_event', 'click_rfpList'); };
			if(this.Value === 'close') { this.Analytics.GA4Event('ga_event', 'click_exitRfp'); };
			this.$emit('update:modelValue', this.Value);
			this.$emit('change', this.Value);
		},
	},
};
</script>

<style lang="scss">
.dropdown.is-arrowless {
	& > button::after {
		display: none;
	}
	.suggestions-list {
		top: 2rem;
	}

	&.is-focused .suggestions-list {
		width: fit-content;
	}
}
</style>
